export class InteropTest {
    // Void return
    public testVoid(name: string): void {
        console.log(`Interop test successful! Hello from ${name}.`);
    }
    
    // Typed return
    public testReturnType(name: string): string {
        return `Interop test successful! Hello from ${name}. This one returned a string value back to C#.`;
    }

    // Call C# from TS example
    private returnArrayAsync(): void {
        // Access DotNet from the window object
        const dotNet: any = (window as any).DotNet;
        
        if (dotNet) {
            dotNet.invokeMethodAsync('nickfazzdev', 'ReturnArrayAsync')
                .then((data: number[]) => {
                    console.log('Received from .NET:', data);
                })
                .catch((error: any) => {
                    console.error('Error calling .NET method:', error);
                });
        } else {
            console.error('DotNet is not available');
        }
    }
    
    public addHandlers(): void {
        const btn: HTMLElement | null = document.getElementById("btn");
        
        if (btn) {
            btn.addEventListener("click", () => this.returnArrayAsync());
        }
    }
    
    // Send a C# class object as a parameter
    public sendParams(params: any): void {
        console.log(params.name);
        console.log(params.color);
        console.log(params.size);
    }
}